import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { OutpostAttemptView, OutpostEventView } from '../../../../../../typings/View.interface';
import { formatPath } from '../../../utils/path';
import ErrorBoundary from '../../common/helpers/ErrorBoundary';
import { DashboardLayout, DashboardLayoutContent } from '../../layouts/ViewLayout';
import { DashboardContext } from '../DashboardScene/DashboardContext';
import { ViewsContextProvider } from '../DashboardScene/ViewsContext';
import OperatorEventsView from './OperatorEvents';
import OperatorEventView from './OperatorEvents/OperatorEventView';
import AttemptsView from './Attempts/AttemptsView';
import AttemptView from './Attempts/AttemptView';
import DestinationView from './Destinations/DestinationView';
import EventView from './Event/EventView';
import EventsView from './Events/EventsView';
import GetStarted from './GetStarted/GetStartedView';
import MetricsView from './Metrics';
import { OutpostContextProvider } from './OutpostContext';
import OutpostInitializingOverlay from './OutpostInitializingOverlay';
import OutpostNav from './OutpostNav';
import Settings from './Settings';
import TenantsView from './Tenants/TenantsView';
import TenantView from './Tenants/TenantView';
import ViewRoute from '../../common/ViewRoute';
const OutpostDashboardScene: React.FC<{
  banner_active: boolean;
}> = t0 => {
  const $ = _c(8);
  const {
    banner_active
  } = t0;
  const {
    nav_collapsed
  } = useContext(DashboardContext);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <OutpostNav />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <OutpostInitializingOverlay><ErrorBoundary><Switch><Route path="/settings" component={Settings} /><ViewRoute usePathAsTitle={true} path="/tenants/:id/destinations/:destination_id" component={DestinationView} /><ViewRoute usePathAsTitle={true} path="/tenants/:id" component={TenantView} /><ViewRoute usePathAsTitle={true} path="/tenants" component={TenantsView} /><ViewRoute usePathAsTitle={true} path="/operator-events/:event_id" component={OperatorEventView} /><ViewRoute usePathAsTitle={true} path="/operator-events" component={OperatorEventsView} /><ViewRoute usePathAsTitle={true} path="/metrics" component={MetricsView} /><ViewRoute usePathAsTitle={true} path="/events" render={_temp3} /><ViewRoute usePathAsTitle={true} path="/deliveries" render={_temp6} /><ViewRoute usePathAsTitle={true} path="/get-started" component={GetStarted} /><Redirect to="/tenants" /></Switch></ErrorBoundary></OutpostInitializingOverlay>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== banner_active) {
    t3 = <DashboardLayoutContent id="main" banner_active={banner_active}>{t2}</DashboardLayoutContent>;
    $[2] = banner_active;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== banner_active || $[5] !== nav_collapsed || $[6] !== t3) {
    t4 = <OutpostContextProvider><DashboardLayout nav_collapsed={nav_collapsed} banner_active={banner_active}>{t1}{t3}</DashboardLayout></OutpostContextProvider>;
    $[4] = banner_active;
    $[5] = nav_collapsed;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default OutpostDashboardScene;
function _temp(view) {
  return <ViewRoute key={view.id} path={`/events/${formatPath(view.name)}`}><EventsView current_view={view as OutpostEventView} /></ViewRoute>;
}
function _temp2(t0) {
  const {
    views
  } = t0;
  return views && <Switch>{views.models.map(_temp)}<ViewRoute usePathAsTitle={true} path="/events/:id" component={EventView} /><ViewRoute usePathAsTitle={true} path="/events" component={EventsView} /></Switch>;
}
function _temp3() {
  return <ViewsContextProvider type="outpost_events" redirect_root="/events">{_temp2}</ViewsContextProvider>;
}
function _temp4(view_0) {
  return <ViewRoute key={view_0.id} path={`/deliveries/${formatPath(view_0.name)}`}><AttemptsView current_view={view_0 as OutpostAttemptView} /></ViewRoute>;
}
function _temp5(t0) {
  const {
    views: views_0
  } = t0;
  return views_0 && <Switch>{views_0.models.map(_temp4)}<ViewRoute usePathAsTitle={true} path="/deliveries/:id" component={AttemptView} /><ViewRoute usePathAsTitle={true} path="/deliveries" component={AttemptsView} /></Switch>;
}
function _temp6() {
  return <ViewsContextProvider type="outpost_attempts" redirect_root="/deliveries">{_temp5}</ViewsContextProvider>;
}